import { Button, ButtonProps, SimplifiedTooltip } from '@moleculeone/ui';
import { Target } from '@retro-ui/api-contract';
import { CellContext } from '@tanstack/react-table';

interface ActionButtonProps extends ButtonProps {
  cellContext: CellContext<Target, string>;
  tooltip?: React.ReactNode;
  onActionClick: (rowIndex: number) => void;
}

export function ActionButton(props: ActionButtonProps) {
  const { cellContext: ctx, tooltip, onActionClick, ...buttonProps } = props;
  const rowCount = ctx.table.options.data.length;

  const isLastRow = ctx.row.index === rowCount - 1;

  const onButtonClick = () => {
    onActionClick(ctx.row.index);
  };

  return (
    <SimplifiedTooltip content={tooltip} contentProps={{ side: 'bottom' }}>
      <Button weight="minimal" disabled={isLastRow} onClick={onButtonClick} {...buttonProps} />
    </SimplifiedTooltip>
  );
}
